import { render, staticRenderFns } from "./ManangeTransfers.vue?vue&type=template&id=c0021aa2&scoped=true"
import script from "./ManangeTransfers.vue?vue&type=script&lang=js"
export * from "./ManangeTransfers.vue?vue&type=script&lang=js"
import style0 from "./ManangeTransfers.vue?vue&type=style&index=0&id=c0021aa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0021aa2",
  null
  
)

export default component.exports